"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("./helpers");
if (window.c2m === undefined) {
    window.c2m = {
        helpers: (0, helpers_1.createC2mHelpers)(window.axios),
    };
}
else {
    window.c2m.helpers = (0, helpers_1.createC2mHelpers)(window.axios);
}
